import React from "react";
import { Button, Table } from "react-bootstrap";
import { BlogRecord } from "../../../../services/blogService";

interface BlogTableProps {
	blogs: BlogRecord[];
	loading: boolean;
	onOpen: (blogId: string) => void;
}

const formatDate = (value?: string | null) => {
	if (!value) {
		return "-";
	}
	return new Date(value).toLocaleString();
};

const hasSeo = (blog: BlogRecord) => {
	const metaTitle = blog?.seo?.metaTitle?.trim();
	const metaDescription = blog?.seo?.metaDescription?.trim();
	return Boolean(metaTitle && metaDescription);
};

const BlogTable = ({ blogs, loading, onOpen }: BlogTableProps) => {
	if (loading) {
		return <div>Loading blogs...</div>;
	}

	return (
		<Table striped bordered hover responsive>
			<thead>
				<tr>
					<th>Title</th>
					<th>Status</th>
					<th>Slug</th>
					<th>Updated</th>
					<th>Published</th>
					<th>SEO</th>
					<th>Actions</th>
				</tr>
			</thead>
			<tbody>
				{blogs.length === 0 ? (
					<tr>
						<td colSpan={7} className="text-center">
							No blogs found.
						</td>
					</tr>
				) : (
					blogs.map((blog) => (
						<tr key={blog._id} onClick={() => onOpen(blog._id)}>
							<td>{blog.title}</td>
							<td className="text-capitalize">{blog.status}</td>
							<td>{blog.slug}</td>
							<td>{formatDate(blog.updatedAt)}</td>
							<td>{formatDate(blog.publishedAt)}</td>
							<td>{hasSeo(blog) ? "Complete" : "Missing"}</td>
							<td>
								<Button
									size="sm"
									variant="outline-primary"
									onClick={(event) => {
										event.stopPropagation();
										onOpen(blog._id);
									}}
								>
									Edit
								</Button>
							</td>
						</tr>
					))
				)}
			</tbody>
		</Table>
	);
};

export default BlogTable;
